/** Вкладки подання «Етапи» (прототип v4 stageTabs): значення поля з лічильниками в межах фільтрів списку й вибрана вкладка. */
import type { IStatBucket } from '@platform/core/types';

/**
 * Вибрана вкладка: збережена, якщо вона серед значень; інакше перше значення із записами, інакше перше значення (null — значень немає).
 * Чиста функція.
 */
export function selectedStage(values: readonly string[], counts: ReadonlyMap<string | null, number>, saved: string | null): string | null {
  if (saved !== null && values.includes(saved)) return saved;
  return values.find((v) => (counts.get(v) ?? 0) > 0) ?? values[0] ?? null;
}

/** Лічильники відер статистики за значенням. */
export function countsOf(buckets: readonly IStatBucket[] | undefined): Map<string | null, number> {
  return new Map((buckets ?? []).map((b) => [b.value, b.count]));
}
